export default {
  DISCORD: "https://discord.gg/65BHkXA5kb",
  DOCS: "https://docs.acre.fi",
  FAQ: "https://docs.acre.fi/faq",
  CONTRACTS: "https://docs.acre.fi/contracts",
  WEBSITE: "https://acre.fi",
  TERMS_OF_USE: "https://acre.fi/terms-of-use",
  PRIVACY_POLICY: "https://acre.fi/privacy-policy",
  X: "https://x.com/AcreBTC",
  MIDAS: "https://midas.app/",
  AAVE: "https://aave.com/",
  GIZA: "https://www.gizatech.xyz/",
  RE7_CAPITAL: "https://re7.capital/",
  WALLET_GUIDE: "https://docs.acre.fi/acre-dapp/sign-in",
  THRESHOLD_ACRE_VAULT: "https://app.threshold.network/vaults/acre",
}
